import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Alert, TextField } from '@mui/material';
import { enableAuthenticator } from './Manage2faEndpoints';

export default function Manage2faAuthenticatorStep2(props) {
    const dialogSubmit = React.useRef(props.dialogSubmit);
    const [recoveryCodes, setRecoveryCodes] = React.useState([]);
    const [isReady, setIsReady] = React.useState(false);
    const [showFormError, setShowFormError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const initialValues = {
        code: ''
    };

    const validationSchema = yup.object({
        code: yup
            .string()
            .required('Verification Code is required')
    });

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                setIsReady(false);
                setShowFormError(false);
                setErrorMessage(null);

                const response = await enableAuthenticator(values);
                if(response.recoveryCodes?.length > 0) {
                    const formattedRecoveryCodes = [];
                    for (let row = 0; row < response.recoveryCodes.length; row += 2) {
                        formattedRecoveryCodes.push(`${response.recoveryCodes[row]} ${response.recoveryCodes[row + 1]}`);
                    }

                    setRecoveryCodes(formattedRecoveryCodes);
                }

                setIsReady(true);
            }
            catch(err) {
                setShowFormError(true);
                if (err.response?.data?.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
                else {
                    setErrorMessage("The code is incorrect");
                }
            }
            finally {
                formik.setSubmitting(false);
            }
        },
    });

    React.useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            formik.handleSubmit();
        }

        if (formik.isValid && isReady) {
            props.onValidate(recoveryCodes);
        }
    });

    return (
        <>
            {showFormError && (
                <Alert sx={{ mt: 2, mb: 2 }} severity="error">{errorMessage}</Alert>
            )}
            <TextField
                type="text"
                name="code"
                label="Verification Code"
                fullWidth
                value={formik.values.code}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.code)}
                helperText={formik.errors.code}
            />
        </>
    );
}